import React from "react";
import { WorkspaceProductsSearch } from "../../WorkspaceProducts/WorkspaceProductsSearch";
import { graphql, useMutation } from "react-relay";
import { UserLoggedInNavigatorScreenProps } from "../../../../TopLevelNavigators/UserLoggedIn/UserLoggedInNavigatorParamList";
import { WebModal } from "../../../../TopLevelNavigators/UserLoggedIn/WebModal";
import { useIntl } from "react-intl";
import { Box } from "arkh";

export function WorkspaceTodoLinkProduct(
  props: UserLoggedInNavigatorScreenProps<"WorkspaceTodoEditLinkProduct">
) {
  const intl = useIntl();
  const [linkProduct] = useMutation(graphql`
    mutation WorkspaceTodoLinkProductMutation(
      $productId: ID!
      $todoWorkspaceId: ID!
    ) {
      todoWorkspace(id: $todoWorkspaceId) {
        linkProduct(productId: $productId) {
          id
        }
      }
    }
  `);

  return (
    <WebModal
      color="transparent"
      shadow={false}
      dismissable
      contentStyle={{
        width: 600,
        maxHeight: 400,
      }}
    >
      <Box
        style={{
          overflow: "hidden",
          maxHeight: 400,
        }}
        cornerRadius="large"
      >
        <WorkspaceProductsSearch
          isSearching
          onPressProduct={(id) => {
            linkProduct({
              variables: {
                productId: id,
                todoWorkspaceId: props.route.params.todoWorkspaceId,
              },
              onCompleted: () => {
                props.navigation.goBack();
              },
            });
          }}
          productIsDisabled={(id) => {
            return props.route.params.linkedProductIds.includes(id)
              ? intl.formatMessage({
                  defaultMessage: "Product is already linked",
                  description: "LinkProductComponent disabled product reason",
                })
              : undefined;
          }}
          workspaceId={props.route.params.workspaceId}
          autoFocus
          showCancel
          onBlur={props.navigation.goBack}
        />
      </Box>
    </WebModal>
  );
}
